import * as React from "react";
import {
    List,
    TextInput,
    TextField,
    FunctionField,
    Datagrid,
    TopToolbar,
    Show,
    ShowButton,
    TabbedShowLayout,
    DateField,
    ExportButton,
    CreateButton,
    FilterButton,
    SimpleForm,
    Create,
    required,
    ReferenceManyCount,
    useRecordContext,
    ReferenceField,
    ReferenceManyField
} from 'react-admin';

import { EditableDatagrid, RowForm } from "@react-admin/ra-editable-datagrid";
import { iconStyle } from '../shared/Styles/iconsStyles';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';
import Typography from "@material-ui/core/Typography";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';

// Importo il css per i Bottoni
import { showButtonCss, createButtonCss, filterButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';

// Custom input
import CustomAutocompleInputUsers from '../shared/FormFields/CustomAutocompleInputUsers';

const ListActions = () => (
    <TopToolbar>

        {/* <ExportButton label="Esporta" sx={exportButtonCss} /> */}
        <CreateButton sx={createButtonCss} />
        <FilterButton sx={filterButtonCss} />

    </TopToolbar>
);


export const CollaboratoriList = props => {

    return (
        <List
            pagination={null}
            title={<>
                <Button>
                    &nbsp;LISTA DEI LOGS
                </Button>
            </>}
            exporter={false}
            actions={<ListActions />}
            // aside={<CollaboratoriFilterSidebar />}
            filters={CollaboratoriFilters}
            {...props}
            // actions={null}
            perPage={100}
        // filters={aziendaFilters}
        >
            <Datagrid sx={listCss} bulkActionButtons={false}>
                {<TextField source="id" label="Id Collaboratore"></TextField>}
                {<TextField source="nominativo" label="Nominativo"></TextField>}
                {<DateField label="Data Creazione" source="createdAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}
                {<DateField label="Data Ultima Modifica" source="updatedAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}

                {<ShowButton sx={showButtonCss} label="Dettaglio" />}
            </Datagrid>
        </List>
    );
}

export const CollaboratoriCreate = (props) => {

    /*     const [create] = useCreate();
        const usersCreate = (data) => {
            create('users', { data });
        }; */

    return (
        <Create title={<>
            <Button>
                &nbsp;Crea Nuovo Collaboratore
            </Button>
        </>} {...props}>
            <SimpleForm redirect="show">
                {<TextInput label="Nominativo" source="nominativo" validate={[required()]} />}
            </SimpleForm>
        </Create>
    );
}


export const CollaboratoriShow = (props) => {
    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio Collaboratore
            </Button>
        </>} /* actions={<ShowActions />} */ actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                <strong>Collaboratore Id:</strong> <TextField source="id"></TextField>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                Nominativo: <FunctionField source="nominativo" render={record => record && `${record.nominativo}`} />
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Accessi Collaboratore" count={<ReferenceManyCount reference="users-collaboratori"
                    target="tblCollaboratoriId" />}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12}>
                            <Alert severity="info">Attenzione, in questo tab puoi selezionare solo user con ruolo <strong>Collaboratore</strong></Alert>
                            <ReferenceManyField
                                reference="users-collaboratori"
                                target="tblCollaboratoriId"
                                sort={{ field: 'id', order: 'ASC' }}
                            >
                                <GestioneUsersInShow></GestioneUsersInShow>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </TabbedShowLayout.Tab>
                <TabbedShowLayout.Tab label="Candidati Visibili" count={<ReferenceManyCount reference="users-collaboratori-candidati"
                    target="tblCollaboratoriId" />}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12}>
                            <Alert severity="info">Attenzione, in questo tab puoi selezionare solo user con ruolo <strong>Candidati</strong></Alert>
                            <ReferenceManyField
                                reference="users-collaboratori-candidati"
                                target="tblCollaboratoriId"
                                sort={{ field: 'id', order: 'ASC' }}
                            >
                                <GestioneUsersCandidatiInShow></GestioneUsersCandidatiInShow>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </TabbedShowLayout.Tab>
            </TabbedShowLayout>
        </Show>
    );
}

const GestioneUsersInShow = ({ id, ...props }) => {

    const record = useRecordContext();
    if (!record) return null;

    return (<EditableDatagrid
        bulkActionButtons={false}
        editForm={<UsersShowDisponibiliRowForm />}
        createForm={<UsersShowDisponibiliRowForm id={record.id} />}
    >
        <Card variant="outlined"
            sx={{ margin: 1, borderRadius: 2 }}
        >
            <CardContent>
                <ReferenceField source="usersId" reference="users" link={false}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 56, height: 56, marginRight: 2 }}>

                        </Avatar>
                        <Typography variant="subtitle1" component="div">
                            ID User : <TextField source="id" />
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1/* , color: 'primary.main' */ }}>
                        <Typography variant="subtitle1" component="div">
                            Email : <strong><TextField source="email" /></strong>
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1/* , color: 'primary.main' */ }}>
                        <Typography variant="subtitle1" component="div">
                            {<FunctionField
                                source="usersId"
                                render={record => {
                                    console.log(record);
                                    return <NavigateButton recordId={record.id} service="users" message="Dettaglio User"></NavigateButton>;
                                }}
                            />}
                        </Typography>
                    </Box>

                </ReferenceField>
            </CardContent>
        </Card>
    </EditableDatagrid>);

}

const GestioneUsersCandidatiInShow = ({ id, ...props }) => {

    const record = useRecordContext();
    if (!record) return null;

    return (<EditableDatagrid
        bulkActionButtons={false}
        editForm={<UsersShowCandidatiDisponibiliRowForm />}
        createForm={<UsersShowCandidatiDisponibiliRowForm id={record.id} />}
    >
        <Card variant="outlined"
            sx={{ margin: 1, borderRadius: 2 }}
        >
            <CardContent>
                <ReferenceField source="usersId" reference="users" link={false}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 56, height: 56, marginRight: 2 }}>

                        </Avatar>
                        <Typography variant="subtitle1" component="div">
                            ID User : <TextField source="id" />
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1/* , color: 'primary.main' */ }}>
                        <Typography variant="subtitle1" component="div">
                            Email : <strong><TextField source="email" /></strong>
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1/* , color: 'primary.main' */ }}>
                        <Typography variant="subtitle1" component="div">
                            {<FunctionField
                                source="usersId"
                                render={record => {
                                    console.log(record);
                                    return <NavigateButton recordId={record.id} service="users" message="Dettaglio User"></NavigateButton>;
                                }}
                            />}
                        </Typography>
                    </Box>

                </ReferenceField>
            </CardContent>
        </Card>
    </EditableDatagrid>);

}

const NavigateButton = ({ recordId, service, message }) => {
    const handleNavigate = () => {

        const url = `#/${service}/${recordId}/show`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Button sx={showButtonCss} onClick={handleNavigate}>{message}</Button>
    );
}

const UsersShowDisponibiliRowForm = ({ id, ...props }) => {
    return (
        <RowForm  {...props}>
            <TextInput source="tblCollaboratoriId" defaultValue={parseInt(id)} disabled ></TextInput>
            <CustomAutocompleInputUsers isFiltered={true} filterField="roles" filterValue="collaboratore" source="usersId" reference="users" optionProperty="email" label="" ></CustomAutocompleInputUsers>

        </RowForm>
    );

}

const UsersShowCandidatiDisponibiliRowForm = ({ id, ...props }) => {
    return (
        <RowForm  {...props}>
            <TextInput source="tblCollaboratoriId" defaultValue={parseInt(id)} disabled ></TextInput>
            <CustomAutocompleInputUsers isFiltered={true} filterField="roles" filterValue="candidato" source="usersId" reference="users" optionProperty="email" label="" ></CustomAutocompleInputUsers>

        </RowForm>
    );

}

const ShowTopToolbarDettaglio = () => (
    <TopToolbar>
        <ShowButton sx={showButtonCss} label="Dettaglio" />
    </TopToolbar>
);

const ShowActionsForEdit = () => (
    <ShowTopToolbarDettaglio></ShowTopToolbarDettaglio>
);



const CollaboratoriFilters = [
    <TextInput source="id" label="Collaboratori Id" />,
    <TextInput source="nominativo" label="Nominativo" />,
];